import { Row } from 'antd';
import classnames from 'classnames';
import { useParams } from 'react-router-dom';

import { useGetFacilityContacts } from './hooks';
import { AgGridReact } from 'ag-grid-react';
import { columnDefsContacts } from './constants';

const QaSpecContactAddress = ({ setRowSelected }) => {
  const { id } = useParams();

  const { facilityContacts } = useGetFacilityContacts(id);

  return (
    <Row style={{ width: '100%', height: 'calc(100% - 40px)' }}>
      <div
        style={{
          height: '100%',
          width: '100%',
        }}
        className={classnames(
          'ag-theme-alpine',
          'ag-theme-alpine--with-scroller',
          'process-stage__grid-container'
        )}
      >
        <AgGridReact
          headerHeight={32}
          rowHeight={32}
          columnDefs={columnDefsContacts}
          rowData={facilityContacts}
          rowSelection='multiple'
          onSelectionChanged={(data) => {
            const selectedRows = data?.api?.getSelectedRows();

            setRowSelected(selectedRows);
          }}
        />
      </div>
    </Row>
  );
};

export default QaSpecContactAddress;
